module.exports = __webpack_public_path__ + "assets/img/1.90b42f08.png";